import React from 'react';

import ColumnTitle from './ColumnTitle.jsx';

const TableHeader = (props) => {
    let icon = false;
    let functionExport = null;
    let functions = props.functions;

    if (props != undefined) {
        if (props.column != undefined) {
            icon = props.column[props.columnIndex].state
        }

        if (functions) {
            functionExport = functions.find(c => c.Codigo_Funcion == "Export");
        }
    }

    return (
        <thead>
            <tr>
                <th>
                    <div className="checkbox-container">
                        <input type="checkbox" id="header-check"
                            value={props.id}
                            onClick={() => props.setAllCheckbox(!props.allCheckboxFilter, props.currentUser)} />
                        <label htmlFor="header-check"></label>
                    </div>
                </th>
                <th>
                    <ColumnTitle title="NOMBRE" columnIndex={0} order={(props.columnIndex == 0)} icon={icon} orderColumn={props.orderColumn} />
                </th>
                <th>
                    <ColumnTitle title="LOGIN" columnIndex={1} order={(props.columnIndex == 1)} icon={icon} orderColumn={props.orderColumn} />
                </th>
                <th>
                    <ColumnTitle title="SUCURSAL" columnIndex={2} order={(props.columnIndex == 2)} icon={icon} orderColumn={props.orderColumn} />

                </th>
                <th>
                    <ColumnTitle title="SECTOR" columnIndex={3} order={(props.columnIndex == 3)} icon={icon} orderColumn={props.orderColumn} />
                </th>
                <th className="table-head-width">
                    {functionExport &&
                        <div className="dropdown">
                            <button className="btn btn-default" data-toggle="dropdown">Exportar</button>
                            <ul className="dropdown-menu">
                                <li>
                                    <p> <a href="#" className="list-group-item"> CSV </a> </p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item"> TSV para Excel </a></p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item"> Excel (xlsx) </a></p>
                                </li>
                                <li>
                                    <p><a href="#" className="list-group-item">PDF</a></p>
                                </li>
                            </ul>
                        </div>
                    }
                </th>
            </tr>
        </thead>
    );
}

export default TableHeader;